<div class="bg-white rounded-lg border max-w-xl">

    <div class="px-5 py-2 flex items-center">
        <span class="cursor-grab w-full flex items-center" cdkDragHandle><i class="ri-draggable"></i> <span
                class="text-xs font-semibold">Video From</span></span>
        <span class="divider divider-horizontal"></span>
        <span class="flex gap-3">

            @if (flag == 1) {
            @if (!isPreview) {
<button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && addVideoStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
<button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteVideoStructureNew()"><i class="ri-delete-bin-7-line"></i></button>
            }
            }@else{

            @if (isPreview) {
            <button *ngIf="isPreview" class="btn btn-sm btn-circle bg-white text-zinc-600"
[disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && (isPreview = false)"><i class="ri-pencil-fill"></i></button>
<button class="btn btn-sm btn-circle bg-white text-red-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && deleteVideoStructure(videoData?.id)"><i class="ri-delete-bin-7-line"></i></button>
            }@else{
<button class="btn btn-sm btn-circle bg-white text-zinc-600" [disabled]="coursePublished && flag !== 1"
                (click)="!(coursePublished && flag !== 1) && closePreview()"><i class="ri-close-line"></i></button>
<button class="btn btn-sm btn-circle bg-white text-green-600" [disabled]="coursePublished && flag !== 1 || isSubmitting"
                (click)="!(coursePublished && flag !== 1) && !isSubmitting && UpdateVideoStructure()">
                @if (isSubmitting) {<i class="ri-loader-4-line animate-spin"></i>}@else{<i class="ri-check-line"></i>}
              </button>
            }
            }

        </span>
    </div>
    <hr>
    @if (isPreview) {
    <!-- preview -->
    <div class="p-5">
    <div class="w-full bg-white flex items-center gap-5 h-[7rem]">

        <!-- Image -->
        <div class="w-[8rem] h-full shrink-0">
            <img
                class="h-full w-full object-cover rounded-md"
                src="{{thumbnailUrl}}"
                alt="">
        </div>

        <!-- Details -->
        <ul class="w-full capitalize space-y-2 overflow-hidden">

            <li class="flex items-center gap-2">
                <span class="uppercase text-xs text-zinc-500 shrink-0">
                    Title :
                </span>

                <span
                    class="font-medium text-sm truncate max-w-[200px]"
                    [title]="videoData?.video_title">

                    {{ videoData?.video_title }}

                </span>
            </li>

            <li class="flex items-center gap-2">
                <span class="uppercase text-xs text-zinc-500 shrink-0">
                    Price :
                </span>

                <span class="font-medium text-sm">
                    {{ videoData?.price }}
                </span>
            </li>

            <li class="flex items-center gap-2">
                <span class="uppercase text-xs text-zinc-500 shrink-0">
                    Views :
                </span>

                <span class="font-medium text-sm">
                    {{ videoData?.no_of_views }}
                </span>
            </li>

            <li class="flex items-center gap-2">
                <span class="uppercase text-xs text-zinc-500 shrink-0">
                    Reel :
                </span>

                <span class="font-medium text-sm">
                    {{ videoData?.is_reel_link == true ? 'yes' : 'no' }}
                </span>
            </li>

        </ul>
    </div>
</div>
    <!-- preview -->
    }@else {
    <!-- form -->
    <div class="p-5">
        <form [formGroup]="videoForm">
            <div class="grid grid-cols-2 gap-5">

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold req">Video Title</span>
                        </div>
                        <input
                            [ngClass]="{ 'error': videoForm.get('video_title')?.touched && videoForm.get('video_title')?.hasError('required') }"
                            type="text" formControlName="video_title" placeholder=""
                            class="input input-sm input-bordered w-full " />
                        
                        @if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('required')){
                        <span class="text-xs text-red-500">Title is required</span>
                        }

@if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('videoTitleMaxLength')){
                        <span class="text-xs text-red-500">Title must be at most 150 characters.</span>
                        }

                        @if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('videoTitleMinLength')){
                        <span class="text-xs text-red-500">Title must be at least 3 characters long.</span>
                        }

                        @if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('videoTitleAllowedChars')){
                        <span class="text-xs text-red-500">Title can only contain alphabets, numbers, spaces, hyphens (-), dots (.), and ampersands (&).</span>
                        }

                        @if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('videoTitleNoAllSpaces')){
                        <span class="text-xs text-red-500">Title cannot contain only spaces.</span>
                        }

                        @if (videoForm.get('video_title')?.touched &&
                        videoForm.get('video_title')?.hasError('videoTitleTrim')){
                        <span class="text-xs text-red-500">Title cannot have leading or trailing spaces.</span>
                        }

                    </label>
                </div>

                <div class="col-span-2" [ngClass]="{ 'error': videoForm.errors?.['atLeastOneRequired'] && (videoForm.dirty || videoForm.touched) }" >
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Video Link</span>
                        </div>
                        <div class="">
                            <input
                                [ngClass]="{ 'error': videoForm.get('video_link')?.touched && (videoForm.get('video_link')?.hasError('videoLinkInvalidUrl') || videoForm.get('video_link')?.hasError('videoLinkMaxLength')) }"
                                type="text" formControlName="video_link" placeholder=""
                                class="input input-sm input-bordered w-full " />
                            
                            @if ( videoForm.get('video_link')?.touched &&
                            videoForm.get('video_link')?.hasError('videoLinkInvalidUrl')) {
                            <span class="text-xs text-red-500">Please enter a valid video link (YouTube, Vimeo, or MP4 URL).</span>
                            }

                            @if ( videoForm.get('video_link')?.touched &&
                            videoForm.get('video_link')?.hasError('videoLinkMaxLength')){
                            <span class="text-xs text-red-500">Video link must be at most 500 characters.</span>
                            }

                            <div class="divider text-xs text-zinc-500">OR</div>
                            <input type="file" (change)="setVideoFIle($event)" accept="video/*"
                                class="file-input file-input-bordered file-input-sm w-full " />
                        </div>

                        @if (videoForm.errors?.['atLeastOneRequired'] && (videoForm.dirty || videoForm.touched)) {
                        <span class="text-xs text-red-500">One of the video link or video file is required.</span>
                        }

                    </label>

                    <div class="mt-3 flex items-center gap-3">

                        <div class="flex items-center gap-2">
                            <input type="checkbox" (change)="setLockStatus($event,'video_lock')"
                                class="checkbox checkbox-sm" value="lock"
                                [checked]="(videoData?.video_lock || []).includes('lock')" />
                            <label for="lock" class="">Lock</label>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="checkbox" (change)="setLockStatus($event,'video_lock')"
                                class="checkbox checkbox-sm" value="show"
                                [checked]="(videoData?.video_lock || []).includes('show')" />
                            <label for="show" class=""> Show</label>
                        </div>

                    </div>

                </div>

                <div class="col-span-2 flex items-center justify-between">
                    <label for="">Is Reel link?</label>
                    <input type="checkbox" id="benifits" formControlName="is_reel_link"
                        class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                </div>

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold req">Video Duration (In Seconds)</span>
                        </div>

                        <input
                            [ngClass]="{ 'error': videoForm.get('video_duration')?.touched && videoForm.get('video_duration')?.hasError('required') }"
                            min="1" type="number" formControlName="video_duration" placeholder=""
                            class="input input-sm input-bordered w-full " appNonNegative/>
                        @if (videoForm.get('video_duration')?.touched &&
                        videoForm.get('video_duration')?.hasError('required')){
                        <span class="text-xs text-red-500">Duration is required</span>
                        }
                    </label>
                </div>

                <div class="col-span-2">
                    <label class="form-control w-full">
                        <div class="label">
                            <span class="label-text text-sm font-semibold">Theory</span>
                            <input type="checkbox" id="benifits" (change)="hasTheory = !hasTheory" [checked]="hasTheory"
                                class="toggle toggle-sm toggle-success checked:[--tglbg:#2563eb] checked:bg-white" />
                        </div>
                        @if (hasTheory) {
                        <textarea name="" id="" class="textarea textarea-bordered" formControlName="theory"></textarea>
                        
                        @if (videoForm.get('theory')?.touched &&
                        videoForm.get('theory')?.hasError('theoryMinLength')){
                        <span class="text-xs text-red-500">Theory must be at least 10 characters long.</span>
                        }

                        @if (videoForm.get('theory')?.touched &&
                        videoForm.get('theory')?.hasError('theoryMaxLength')){
                        <span class="text-xs text-red-500">Theory must be at most 5000 characters.</span>
                        }

                        @if (videoForm.get('theory')?.touched &&
                        videoForm.get('theory')?.hasError('theoryNoAllSpaces')){
                        <span class="text-xs text-red-500">Theory cannot contain only spaces.</span>
                        }
                        }
                    </label>

                    <div class="mt-3 flex items-center gap-3">

                        <div class="flex items-center gap-2">
                            <input type="checkbox" class="checkbox checkbox-sm"
                                (change)="setLockStatus($event,'theory_lock')" value="lock"
                                [checked]="(videoData?.theory_lock || []).includes('lock')" />
                            <label for="lock" class="">Lock</label>
                        </div>
                        <div class="flex items-center gap-2">
                            <input type="checkbox" class="checkbox checkbox-sm"
                                (change)="setLockStatus($event,'theory_lock')" value="show"
                                [checked]="(videoData?.theory_lock || []).includes('show')" />
                            <label for="show" class=""> Show</label>
                        </div>

                    </div>
                </div>

                <div class="col-span-2 grid grid-cols-3 gap-3">

                    <div class="col-span-1 flex flex-col items-center">
                        <div
                            class="w-full aspect-square border-2 border-zinc-300 border-dashed rounded-md flex justify-center items-center relative group hover:border-zinc-500 overflow-hidden">

                            @if (thumbnailUrl) {
                            <div>
                                <img class="w-full h-full object-cover" src="{{thumbnailUrl}}" alt="">
                                <div
                                    class="flex items-center justify-center gap-2 text-white bg-black/50 backdrop-blur-sm absolute top-0 left-0 w-full h-full opacity-0 transition duration-300 group-hover:opacity-100">
                                    <div class="flex items-center gap-2 cursor-pointer">
                                        <i class="ri-image-edit-fill text-3xl "></i>
                                        <p class="text-sm  border-l border-white pl-2 font-medium ">Change <br> Thumbnail</p>
                                    </div>
                                </div>
                            </div>
                            }@else {
                            <div class="flex flex-col text-center items-center gap-2 text-zinc-400">
                                <i class="ri-image-fill text-3xl group-hover:text-zinc-500"></i>
                                <p class="text-sm pl-2 font-medium">Upload Thumbnail <br> <span class="text-xs">500 x
                                        500</span></p>
                            </div>
                            }
                            <input type="file" (change)="onFileSelected($event)"
                                class="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer" accept="image/*"
                                name="" id="">
                        </div>

                        <div class="mt-3 flex items-center gap-3">

                            <div class="flex items-center gap-2">
                                <input type="checkbox" (change)="setLockStatus($event,'thumbnail_lock')" value="lock"
                                    class="checkbox checkbox-sm"
                                    [checked]="(videoData?.thumbnail_lock || []).includes('lock')" />
                                <label for="lock" class="">Lock</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <input type="checkbox" (change)="setLockStatus($event,'thumbnail_lock')" value="show"
                                    class="checkbox checkbox-sm"
                                    [checked]="(videoData?.thumbnail_lock || []).includes('show')" />
                                <label for="show" class=""> Show</label>
                            </div>

                        </div>

                    </div>
                    <div class="col-span-2 bg-zinc-100 rounded-lg p-3">

                        <div class="">
                            <label class="form-control w-full">
                                <div class="label">
                                    <span class="label-text text-sm font-semibold req">No of View's</span>
                                </div>
                                <label class="input input-sm input-bordered flex items-center gap-2"
                                    [ngClass]="{ 'error': videoForm.get('no_of_views')?.touched && (videoForm.get('no_of_views')?.hasError('required') || videoForm.get('no_of_views')?.hasError('nonNegativeIntegerDigits') || videoForm.get('no_of_views')?.hasError('nonNegativeIntegerMin')) }">
                                    <i class="ri-eye-line"></i>
                                    <input min="0" appNonNegative type="number" formControlName="no_of_views" class="grow" />
                                </label>
                                @if (videoForm.get('no_of_views')?.touched &&
                                videoForm.get('no_of_views')?.hasError('required')) {
                                <span class="text-xs text-red-500">No of views is required</span>
                                }
                                @if (videoForm.get('no_of_views')?.touched &&
                                videoForm.get('no_of_views')?.hasError('nonNegativeIntegerDigits')) {
                                <span class="text-xs text-red-500">No of views must be a non-negative integer.</span>
                                }
                                @if (videoForm.get('no_of_views')?.touched &&
                                videoForm.get('no_of_views')?.hasError('nonNegativeIntegerMin')) {
                                <span class="text-xs text-red-500">No of views cannot be negative.</span>
                                }
                            </label>
                        </div>

                        <div class="mt-3 flex items-center gap-3">

                            <div class="flex items-center gap-2">
                                <input type="checkbox" (change)="setLockStatus($event,'views_lock')" value="lock"
                                    class="checkbox checkbox-sm" [checked]="(videoData?.views_lock || []).includes('lock')" />
                                <label for="lock" class="">Lock</label>
                            </div>
                            <div class="flex items-center gap-2">
                                <input type="checkbox" (change)="setLockStatus($event,'views_lock')" value="show"
                                    class="checkbox checkbox-sm" [checked]="(videoData?.views_lock || []).includes('show')" />
                                <label for="show" class=""> Show</label>
                            </div>

                        </div>

                        <div class="">
                            <label class="form-control w-full">
                                <div class="label">
                                    <span class="label-text text-sm font-semibold req">Price</span>
                                </div>
                                <label class="input input-sm input-bordered flex items-center gap-2"
                                    [ngClass]="{ 'error': videoForm.get('price')?.touched && (videoForm.get('price')?.hasError('required') || videoForm.get('price')?.hasError('nonNegativeIntegerDigits') || videoForm.get('price')?.hasError('nonNegativeIntegerMin')) }">
                                    ₹
                                    <input min="1" appNonNegative type="number" class="grow" formControlName="price" />
                                </label>
                                @if (videoForm.get('price')?.touched && videoForm.get('price')?.hasError('required')) {
                                <span class="text-xs text-red-500">Price is required</span>
                                }
                                @if (videoForm.get('price')?.touched && videoForm.get('price')?.hasError('nonNegativeIntegerDigits')) {
                                <span class="text-xs text-red-500">Price must be a non-negative integer.</span>
                                }
                                @if (videoForm.get('price')?.touched && videoForm.get('price')?.hasError('nonNegativeIntegerMin')) {
                                <span class="text-xs text-red-500">Price must be at least 0.</span>
                                }
                            </label>
                        </div>



                    </div>



                </div>




            </div>
        </form>
    </div>
    <!-- form -->
    }

</div>